import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const pickyEatingChild: BlogMetaData = {
  title: '偏食の子どもへの対応｜原因と無理なく直す5つの工夫【モンテッソーリ】',
  description:
    '子どもの偏食はなぜ起こる？発達的な原因と、無理に食べさせない5つの工夫を、モンテッソーリの「自分で選ぶ」日常生活の練習の視点で解説。栄養が心配なときの相談先の目安も紹介します。',
  thumbnailUrl: '/img/blog-picky-eating-child.webp',
  filePath: buildBlogFilePath('picky-eating-child'),
  category: BLOG_CATEGORY.PARENTING,
};
